import { getErrorData, type IErrorData } from '../../../utils/getErrorData';
import { type IProduct } from '../../../types/IProduct';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProductByIdV2 } from '../../../hooks/productApi';

export const getProductByIdThunk = createAsyncThunk<
  IProduct,
  { productId: number },
  { rejectValue: IErrorData }
>('product/getProductByIdThunk', async (options, { rejectWithValue }) => {
  try {
    const productResponse = await getProductByIdV2(options.productId);
    return productResponse;
  } catch (error) {
    const errorData = getErrorData(error);
    return rejectWithValue(errorData);
  }
});
